"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableColumnDef = void 0;
class TableColumnDef {
    constructor() {
        this.showOverflowTooltip = true;
    }
}
exports.TableColumnDef = TableColumnDef;
